import {l} from "types/typescriptdefinisjoner_lederplan";
import {BasisRessurs} from "felles/infrastruktur/BasisRessurs";
import {RessursFeilhåndtering} from "../RessursFeilhåndtering";
import {gettextCatalog} from "angular-gettext";
import _ from "lodash";
import moment from "moment";
import {regNavn} from "../tredjepartsTjenestenavn";
import {Kontekst} from "../Kontekst";
import {Konfigurasjon} from "../../infrastruktur/Konfigurasjon";
import {SakRessurs} from "./SakRessurs";
import {Debugger} from "debug";
import {uriEnkodet} from "../../stoettefunk/uri";
import {Filer} from "../Filer";
import {SakstidspunkterMap} from "felles-ng2/tjenester/Sakstidspunkter";
import {reduserTilSum} from "felles-ng2/støttefunksjoner/lister";
import IResourceArray = ng.resource.IResourceArray;
import Deltakerstatus = l.Deltakerstatus;

require('twix'); //utvider moment

const debug: Debugger = require('debug')('MøteRessurs');

export class MøteRessurs extends BasisRessurs<l.MøteModell> {

    static regNavn = "møteRessurs";

    static forInjisering() {
        return [
            regNavn.ng.$resource,
            Kontekst.regNavn,
            Konfigurasjon.regNavn,
            RessursFeilhåndtering.regNavn,
            regNavn.gettext.gettextCatalog,
            MøteRessurs
        ]
    }

    constructor($resource: ng.resource.IResourceService,
                private kontekst: Kontekst,
                private konfigurasjon: Konfigurasjon,
                ressursFeilhåndtering: RessursFeilhåndtering,
                gettextCatalog: gettextCatalog) {
        super('moete',
            $resource,
            ressursFeilhåndtering,
            gettextCatalog,
            {
                hentEnkel: {method: 'GET', url: '/api/moete/:id/enkel', params: {id: '@id'}},
                hentMedAggregater: {method: 'GET', url: '/api/moete/:id/medAggregater', params: {id: '@id'}},
                hentStatus: {method: 'GET', url: '/api/moete/:id/status', params: {id: '@id'}},
                hentMøtedokumentvalg: {method: 'GET', url: '/api/moete/:id/moetedokumentvalg', params: {id: '@id'}},
                finnMøteIdTilknyttetDeltaker: {method: 'GET', url: '/api/moete/finnMoeteIdTilknyttetDeltaker/:deltakerId', params: {deltakerId: '@deltakerId'}},
                finnMøteIdTilknyttetProtokollførtDeltaker: {method: 'GET', url: '/api/moete/finnMoeteIdTilknyttetProtokollfoertDeltaker/:deltakerId', params: {deltakerId: '@deltakerId'}},
                finnMøteIdTilknyttetSak: {method: 'GET', url: '/api/moete/finnMoeteIdTilknyttetSak/:sakId', params: {sakId: '@sakId'}},
                finnMøteOgSakIdTilknyttetAvstemning: {method: 'GET', url: '/api/moete/finnMoeteOgSakIdTilknyttetAvstemning/:avstemningId', params: {avstemningId: '@avstemningId'}},
                finnMøteOgSakIdTilknyttetBeslutning: {method: 'GET', url: '/api/moete/finnMoeteOgSakIdTilknyttetBeslutning/:beslutningId', params: {beslutningId: '@beslutningId'}},
                finnFørsteMøteEtterEllerFør: {method: 'GET', url: '/api/moete/finnFoersteMoeteEtterEllerFoer', params: {id: ''}},
                finnSisteMøteFør: {method: 'GET', url: '/api/moete/:id/finnSisteMoeteFoer', params: {id: '@id'}},
                finnSenesteLåsteMøte: {method: 'GET', url: '/api/moete/finnSenesteLaasteMoete'},
                finnFørsteMøteEtter: {method: 'GET', url: '/api/moete/:id/finnFoersteMoeteEtter', params: {id: '@id'}},
                finnMøterIPerioden: {method: 'GET', url: '/api/moete/finnMoeterIPerioden', params: {id: ''}, isArray: true},
                finnMoeterEnkelMedProtokollinfoIPerioden: {method: 'GET', url: '/api/moete/finnMoeterEnkelMedProtokollinfoIPerioden', params: {id: ''}},
                finnMøterTilhørendeGruppeIPerioden: {method: 'GET', url: '/api/moete/finnMoeterTilhoerendeGruppeIPerioden', isArray: true},
                finnMøterTilhørendeGrupperIPerioden: {method: 'GET', url: '/api/moete/finnMoeterTilhoerendeGrupperIPerioden', isArray: true},
                finnMøterIPerioden2: {method: 'GET', url: '/api/moete/finnMoeterIPerioden2', params: {id: ''}, isArray: true},
                finnMøteOgOmkringliggende: {method: 'GET', url: '/api/moete/:id/finnMoeteOgOmkringliggende', params: {id: '@id'}, isArray: true},
                finnFørsteMøteOgOmkringliggende: {method: 'GET', url: '/api/moete/finnFoersteMoeteOgOmkringliggende', params: {id: ''}, isArray: true},
                finnFørsteMøteOgOmkringliggende2: {method: 'GET', url: '/api/moete/finnFoersteMoeteOgOmkringliggende2', params: {gruppeIder: '@gruppeIder'}, isArray: true},
                finnMøterMedStartEtter: {method: 'GET', url: '/api/moete/finnMoeterMedStartEtter', params: {dato: '@dato', gruppeIder: '@gruppeIder'}, isArray: true},
                finnMøterMedStartEtter2: {method: 'GET', url: '/api/moete/finnMoeterMedStartEtter2', params: {dato: '@dato', gruppeIder: '@gruppeIder'}, isArray: true},
                finnMøterMedStartFør: {method: 'GET', url: '/api/moete/finnMoeterMedStartFoer', params: {dato: '@dato', gruppeIder: '@gruppeIder'}, isArray: true},
                finnMøterMedStartFør2: {method: 'GET', url: '/api/moete/finnMoeterMedStartFoer2', params: {dato: '@dato', gruppeIder: '@gruppeIder'}, isArray: true},
                finnMøterFørDatoMedUbehandletProtokoll: {method: 'GET', url: '/api/moete/finnMoeterFoerDatoMedUbehandletProtokoll', params: {id: ''}, isArray: true},
                finnAlleKnyttetTilGruppe: {method: 'GET', url: '/api/moete/finnAlleKnyttetTilGruppe', params: {id: ''}, isArray: true},
                finnForsteTilgjengeligeMote: {method: 'GET', url: '/api/moete/finnForsteTilgjengeligeMote', params: {id: ''}},

                valider: {method: 'POST', url: '/api/moete/:id/valider', params: {id: '@id'}},
                validerKopierMøte: {method: 'POST', url: '/api/moete/:id/validerKopierMoete', params: {id: '@id'}},
                kopier: {method: 'PUT', url: '/api/moete/:id/kopier', params: {id: '@id'}, isArray: true},
                registrerVurdering: {method: 'POST', url: '/api/moete/:id/registrerVurdering/:vurdering', params: {id: '@id', vurdering: '@vurdering'}},
                validerNyttMøte: {method: 'POST', url: '/api/moete/validerNyttMoete', params: {id: ""}},
                oppdaterSaksrekkefølge: {method: 'POST', url: '/api/moete/oppdaterSaksrekkefoelge/:id'},
                hentDeltakere: {method: 'GET', url: '/api/moete/:id/deltakere',params: {id: '@id'}},
                oppdaterDeltakere: {method: 'POST', url: '/api/moete/:id/oppdaterDeltakere'},
                sendInnkalling: {method: 'POST', url: '/api/moete/:id/sendInnkalling', params: {id: '@id'}},
                sendInnkallingV2: {method: 'POST', url: '/api/moete/:id/sendInnkallingV2', params: {id: '@id'}},
                sendPurring: {method: 'POST', url: '/api/moete/:id/sendPurring', params: {id: '@id'}},
                annulerInnkalling: {method: 'POST', url: '/api/moete/:id/annulerInnkalling/', params: {id: '@id', deltakerIder: '@deltakerIder'}},

                avstemningsstatus: {method: 'GET', url: '/api/moete/:id/avstemningsstatus/', params: {id: '@id'}},
                oppdaterStemmeberettigede: {method: 'POST', url: '/api/moete/:id/oppdaterStemmeberettigede/', params: {id: '@id'}},
                åpneForAvstemning: {method: 'POST', url: '/api/moete/:id/aapneForAvstemning', params: {id: '@id'}},
                stengForAvstemning: {method: 'POST', url: '/api/moete/:id/stengForAvstemning', params: {id: '@id'}},
                nullstillAvgitteStemmer: {method: 'DELETE', url: '/api/moete/:id/nullstillAvgitteStemmer', params: {id: '@id'}},
                nullstillAvgitteStemmerForDeltaker: {method: 'DELETE', url: '/api/moete/:id/nullstillAvgitteStemmer/:deltakerId', params: {id: '@id', deltakerId: '@deltakerId'}},

                hentSkjerming: {method: 'GET', url: '/api/moete/:id/skjerming', isArray: false},
                oppdaterSkjerming: {method: 'POST', url: '/api/moete/:id/skjerming', isArray: false, params: {id:'@id'}},
                publiserMoete: {method: 'POST', url: '/api/moete/:id/publiser', isArray: false, params: {id:'@id'}},
                sendEpost: {method: 'POST', url: '/api/moete/:id/sendEpost', isArray: false, params: {id:'@id'}},
                oppdaterMøtedokumentvalg: {method: 'POST', url: '/api/moete/:id/oppdaterMoetedokumentvalg', isArray: false, params: {id:'@id'}}
            });
    }

    //offentlige metoder

    hentEnkel(møteId: string): l.MøteModellEnkel {
        console.log("hentEnkel", møteId);
        return this.ressurs["hentEnkel"](
          {id: møteId},
          _.noop,
          this.håndterFeil(() => this.gettextCatalog.getString("Kunne ikke hente møte"))
        );
    }

    hentMedAggregater(møteId: string): l.MøteMedAggregaterModell {
        debug("hentMedAggregater", møteId);
        return this.ressurs["hentMedAggregater"](
            {id: møteId},
            _.noop,
            this.håndterFeil(()=>this.gettextCatalog.getString("Kunne ikke hente møte"))
        );
    }

    hentStatus(møteId: string): l.MoetestatusModell {
        debug("hentStatus", møteId);
        return this.ressurs["hentStatus"](
            {id: møteId},
            _.noop,
            this.håndterFeil(()=>this.gettextCatalog.getString("Kunne ikke hente møte"))
        );
    }

    hentMøtedokumentvalg(møteId: string): l.MøtedokumentvalgModell {
        debug("hentMøtedokumentvalg", møteId);
        return this.ressurs["hentMøtedokumentvalg"](
            {id: møteId},
            _.noop,
            this.håndterFeil(()=>this.gettextCatalog.getString("Kunne ikke hente møtedokumentvalg"))
        );
    }

    finnMøteIdTilknyttetDeltaker(deltakerId: string): l.EntitetIdRespons {
        return this.ressurs["finnMøteIdTilknyttetDeltaker"](
            {deltakerId: deltakerId},
            _.noop,
            this.håndterFeil(()=>this.gettextCatalog.getString("Kunne ikke finne møte-id knyttet til deltaker"))
        );
    }

    finnMøteIdTilknyttetProtokollførtDeltaker(deltakerId: string): l.EntitetIdRespons {
        return this.ressurs["finnMøteIdTilknyttetProtokollførtDeltaker"](
            {deltakerId: deltakerId},
            _.noop,
            this.håndterFeil(()=>this.gettextCatalog.getString("Kunne ikke finne møte-id knyttet til deltaker"))
        );
    }

    finnMøteIdTilknyttetSak(sakId: string): l.EntitetIdRespons {
        return this.ressurs["finnMøteIdTilknyttetSak"](
            {sakId: sakId},
            _.noop,
            this.håndterFeil(()=>this.gettextCatalog.getString("Kunne ikke finne møte-id knyttet til sak"))
        );
    }

    finnMøteOgSakIdTilknyttetAvstemning(avstemningId: string): l.MøteIdOgSakId {
        return this.ressurs["finnMøteOgSakIdTilknyttetAvstemning"](
            {avstemningId: avstemningId},
            _.noop,
            this.håndterFeil(()=>this.gettextCatalog.getString("Kunne ikke finne møte-id og saks-id knyttet til avstemning"))
        );
    }

    finnMøteOgSakIdTilknyttetBeslutning(beslutningId: string): l.MøteIdOgSakId {
        return this.ressurs["finnMøteOgSakIdTilknyttetBeslutning"](
            {beslutningId: beslutningId},
            _.noop,
            this.håndterFeil(()=>this.gettextCatalog.getString("Kunne ikke finne møte-id og saks-id knyttet til beslutning"))
        );
    }

    finnFørsteMøteEtterEllerFør(dato: Date): l.MøteModellEnkel {
        debug("finnFørsteMøteEtterEllerFør");
        return this.ressurs["finnFørsteMøteEtterEllerFør"](
            {dato: dato},
            _.noop,
            this.håndterFeil(()=>this.gettextCatalog.getString("Kunne ikke finne førstkommende møte"))
        );
    }

    finnSisteMøteFør(møteId: string, sammeGruppe = false): l.MøteModell {
        debug("finnSisteMøteFør");
        return this.ressurs["finnSisteMøteFør"](
            {id: møteId, sammeGruppe: sammeGruppe},
            _.noop,
            this.håndterFeil(()=>this.gettextCatalog.getString("Kunne ikke finne forrige møte"))
        );
    }

    finnSenesteLåsteMøte(gruppeId: string): l.MøteModell {
        debug("finnSenesteLåsteMøte");
        return this.ressurs["finnSenesteLåsteMøte"](
            {gruppeId: gruppeId},
            _.noop,
            this.håndterFeil(() => this.gettextCatalog.getString("Kunne ikke finne forrige møte"))
        );
    }

    finnFørsteMøteEtter(møteId: string, sammeGruppe = false): l.MøteModell {
        debug("finnFørsteMøteEtter");
        return this.ressurs["finnFørsteMøteEtter"](
            {id: møteId, sammeGruppe: sammeGruppe},
            _.noop,
            this.håndterFeil(()=>this.gettextCatalog.getString("Kunne ikke finne neste møte"))
        );
    }

    finnMøterMedStartEtter(dato: Date, gruppeIder: string[] = []): IResourceArray<l.MøteMedAggregaterModell> {
        debug("finnMøterMedStartEtter", dato, gruppeIder);
        return this.ressurs["finnMøterMedStartEtter"](
          {dato: dato, gruppeIder: gruppeIder},
          _.noop,
          this.håndterFeil(()=>this.gettextCatalog.getString("Kunne ikke finne møter"))
        );
    }

    finnMøterMedStartFør(dato: Date, gruppeIder: string[] = []): IResourceArray<l.MøteMedAggregaterModell> {
        debug("finnMøterMedStartFør", dato, gruppeIder);
        return this.ressurs["finnMøterMedStartFør"](
          {dato: dato, gruppeIder: gruppeIder},
          _.noop,
          this.håndterFeil(()=>this.gettextCatalog.getString("Kunne ikke finne møter"))
        );
    }

    finnMøteOgOmkringliggende(møteId: string, vedFeil = this.håndterFeil(()=>this.gettextCatalog.getString("Kunne ikke finne møter"))): IResourceArray<l.MøteMedAggregaterModell> {
        debug("finnMøteOgOmkringliggende", møteId);
        return this.ressurs["finnMøteOgOmkringliggende"](
            {id: møteId},
            _.noop,
            vedFeil
        );
    }

    finnFørsteMøteOgOmkringliggende2(gruppeIder:string[] = []): IResourceArray<l.MøteMedAggregaterModell> {
        debug("finnFørsteMøteOgOmkringliggende2", gruppeIder);
        return this.ressurs["finnFørsteMøteOgOmkringliggende2"](
            {gruppeIder:gruppeIder},
            _.noop,
            this.håndterFeil(()=>this.gettextCatalog.getString("Kunne ikke finne møter"))
        );
    }

    //ikke i bruk i ajs kode lenger
    /*/!** møter med startdato senere enn angitt dato, sortert i stigende rekkefølge (tidligste møte først) *!/
    finnMøterMedStartEtter2(dato: Date, gruppeIder: string[] = []): IResourceArray<l.MøteMedAggregaterModell> {
        debug("finnMøterMedStartEtter2", dato, gruppeIder);
        return this.ressurs["finnMøterMedStartEtter2"](
            {dato: dato, gruppeIder: gruppeIder},
            _.noop,
            this.håndterFeil(()=>this.gettextCatalog.getString("Kunne ikke finne møter"))
        );
    }*/

    //ikke i bruk i ajs kode lenger
    /*/!** møter med startdato tidligere enn angitt dato, sortert i stigende rekkefølge (tidligste møte først) *!/
    finnMøterMedStartFør2(dato: Date, gruppeIder: string[] = []): IResourceArray<l.MøteMedAggregaterModell> {
        debug("finnMøterMedStartFør2", dato, gruppeIder);
        return this.ressurs["finnMøterMedStartFør2"](
            {dato: dato, gruppeIder: gruppeIder},
            _.noop,
            this.håndterFeil(()=>this.gettextCatalog.getString("Kunne ikke finne møter"))
        );
    }*/

    finnMøterIPerioden(start: Date, slutt: Date): IResourceArray<l.MøteModell> {
        debug("finnMøterIPerioden", start, slutt);
        return this.ressurs["finnMøterIPerioden"](
            {start: start, slutt: slutt},
            _.noop,
            this.håndterFeil(()=>this.gettextCatalog.getString("Kunne ikke finne møter"))
        );
    }

    finnMoeterEnkelMedProtokollinfoIPerioden(start: Date, slutt: Date, grupperIde: string, offset: number, antall: number): l.SøkeresultatModell<l.MøteModellEnkelMedProtokollinfo> {
        debug("finnMoeterEnkelMedProtokollinfoIPerioden", start, slutt, grupperIde, offset, antall);
        return this.ressurs["finnMoeterEnkelMedProtokollinfoIPerioden"](
            {start: start, slutt: slutt, grupper: [grupperIde], offset: offset, antall: antall},
            _.noop,
            this.håndterFeil(()=>this.gettextCatalog.getString("Kunne ikke finne møter"))
        );
    }

    finnMøterTilhørendeGruppeIPerioden(start: Date, slutt: Date, gruppeId: string): IResourceArray<l.MøteModell> {
        debug("finnMøterTilhørendeGruppeIPerioden", start, slutt, gruppeId);
        return this.ressurs["finnMøterTilhørendeGruppeIPerioden"](
            {start: start, slutt: slutt, gruppe: gruppeId},
            _.noop,
            this.håndterFeil(()=>this.gettextCatalog.getString("Kunne ikke finne møter"))
        );
    }

    finnMøterTilhørendeGrupperIPerioden(start: Date, slutt: Date, gruppeIder: string[]): IResourceArray<l.MøteModellEnkel> {
        debug("finnMøterTilhørendeGrupperIPerioden", start, slutt, gruppeIder);
        return this.ressurs["finnMøterTilhørendeGrupperIPerioden"](
            {start: start, slutt: slutt, gruppeIder: gruppeIder},
            _.noop,
            this.håndterFeil(()=>this.gettextCatalog.getString("Kunne ikke finne møter"))
        );
    }

    finnMøterIPerioden2(start: Date, slutt: Date): IResourceArray<l.MøteMedAggregaterModell> {
        debug("finnMøterIPerioden2", start, slutt);
        return this.ressurs["finnMøterIPerioden2"](
            {start: start, slutt: slutt},
            _.noop,
            this.håndterFeil(()=>this.gettextCatalog.getString("Kunne ikke finne møter"))
        );
    }

    finnMøterFørDatoMedUbehandletProtokoll(dato: Date, gruppeId: string): IResourceArray<l.MøteModellEnkel> {
        debug("finnMøterFørDatoMedUbehandletProtokoll", dato, gruppeId);
        return this.ressurs["finnMøterFørDatoMedUbehandletProtokoll"](
            {dato: dato, gruppeId: gruppeId},
            _.noop,
            this.håndterFeil(()=>this.gettextCatalog.getString("Kunne ikke finne møter"))
        );
    }

    finnAlleKnyttetTilGruppe(gruppeId: string, vedOk: (møter: l.MøteModell[]) => void = _.noop): IResourceArray<l.MøteModellEnkel>[] {
        debug("finnAlleKnyttetTilGruppe", gruppeId);
        return this.ressurs["finnAlleKnyttetTilGruppe"](
            {gruppeId: gruppeId},
            vedOk,
            this.håndterFeil(()=>this.gettextCatalog.getString("Kunne ikke finne møter"))
        );
    }

    finnFørsteTilgjengeligeMøte(nå: Date): l.MøteModellEnkel {
        debug("finnForsteTilgjengeligeMote");
        return this.ressurs["finnForsteTilgjengeligeMote"](
            {dato: nå},
            _.noop,
            this.håndterFeil(()=>this.gettextCatalog.getString("Kunne ikke finne første tilgjengelige møte"))
        );
    }

    validerNyttMøte(spesifikasjon: l.NyttMøteSpesifikasjon): l.ValideringsresultatModell<l.OpprettMøteValideringsfeil> {
        debug("validerNyttMøte", spesifikasjon);
        return this.ressurs["validerNyttMøte"](
            spesifikasjon,
            _.noop,
            this.håndterFeil(()=>this.gettextCatalog.getString("Kunne ikke validere nytt møte"))
        );
    }

    valider(spesifikasjon: l.OppdaterMøteSpesifikasjon): l.ValideringsresultatModell<l.OppdaterMøteValideringsfeil> {
        debug("valider", spesifikasjon);
        return this.ressurs["valider"](
            spesifikasjon,
            _.noop,
            this.håndterFeil(()=>this.gettextCatalog.getString("Kunne ikke validere oppdatering av møte"))
        );
    }

    validerKopierMøte(møteId: string, spesifikasjon: l.KopierMøteTilGrupperSpesifikasjon): l.KopierMøteTilGrupperValideringsfeil {
        debug("validerKopierMøte", møteId, spesifikasjon);
        return this.ressurs["validerKopierMøte"](
            _.defaults({id: møteId}, spesifikasjon),
            _.noop,
            this.håndterFeil(()=>this.gettextCatalog.getString("Kunne ikke validere kopiering av møte"))
        );
    }

    kopier(møteId: string, spesifikasjon: l.KopierMøteTilGrupperSpesifikasjon): l.MøteModell[] {
        debug("kopier", møteId, spesifikasjon);
        return this.ressurs["kopier"](
            _.defaults({id: møteId}, spesifikasjon),
            _.noop,
            this.håndterFeil(()=>this.gettextCatalog.getString("Kunne ikke kopiere møte"))
        );
    }

    oppdaterSaksrekkefølge(møteId: string, saksrekkefølge: string[], vedOk: (entitet: l.MøteModell) => void = _.noop): l.MøteModell {
        debug("oppdaterSaksrekkefølge", møteId, saksrekkefølge);
        return this.ressurs["oppdaterSaksrekkefølge"](
            {id: møteId, saksrekkefoelge: saksrekkefølge},
            vedOk,
            this.håndterFeil(()=>this.gettextCatalog.getString("Kunne ikke oppdatere saksrekkefølge"))
        );
    }

    oppdaterDeltakere(møteId: string, deltakere: string[]): l.MøtedeltakereModell {
        debug("oppdaterDeltakere", møteId, deltakere);
        return this.ressurs["oppdaterDeltakere"](
            {id: møteId, deltakere: deltakere},
            _.noop,
            this.håndterFeil(()=>this.gettextCatalog.getString("Kunne ikke oppdatere deltakere"))
        );
    }

    hentDeltakere(møteId: string): l.MøtedeltakereModell {
        debug("hentDeltakere", møteId);
        return this.ressurs["hentDeltakere"](
          {id: møteId},
          _.noop,
          this.håndterFeil(()=>this.gettextCatalog.getString("Kunne ikke hente deltakere"))
        );
    }

    registrerVurdering(møteId: string, vurdering: number, vedOk: (entitet: l.MøteModell) => void = _.noop): l.MøteModell {
        debug("registrerVurdering", møteId, vurdering);
        return this.ressurs["registrerVurdering"](
            {id: møteId, vurdering: vurdering},
            vedOk,
            this.håndterFeil(()=>this.gettextCatalog.getString("Kunne ikke registrere vurdering"))
        );
    }

    /**
     * @deprecated
     * Fjernes når #309 har fått ny versjon av app rullet ut i app-store.
     */
    sendInnkalling(møteId: string): l.MøtedeltakereModell {
        debug("sendInnkalling", møteId);
        return this.ressurs['sendInnkalling'](
            {id: møteId},
            _.noop,
            this.håndterFeil(()=>this.gettextCatalog.getString("Kunne ikke sende innkalling")));
    }

    sendInnkallingV2(møteId: string, spesifikasjon: l.SendInnkallingSpesifikasjon): l.MøtedeltakereModell {
        debug("sendInnkallingV2", møteId, spesifikasjon, _.defaults({id: møteId}, spesifikasjon));
        return this.ressurs['sendInnkallingV2'](
            _.defaults({id: møteId}, spesifikasjon),
            _.noop,
            this.håndterFeil(()=>this.gettextCatalog.getString("Kunne ikke sende innkalling")));
    }

    sendPurring(møteId: string): l.MøtedeltakereModell {
        debug("sendPurring", møteId);
        return this.ressurs['sendPurring'](
            {id: møteId},
            _.noop,
            this.håndterFeil(()=>this.gettextCatalog.getString("Kunne ikke sende purring på innkalling")));
    }

    //avstemning

    avstemningsstatus(møteId: string): l.AvstemningsstatusModell {
        debug("avstemningsstatus", møteId);
        return this.ressurs['avstemningsstatus'](
            {id: møteId},
            _.noop,
            this.håndterFeil(()=>this.gettextCatalog.getString("Kunne ikke hente avstemningsstatus")));
    }


    oppdaterStemmeberettigede(møteId: string, spesifikasjon: l.StemmeberettigetMøtedeltakerSpesifikasjoner): l.MøtedeltakereModell {
        debug("oppdaterStemmeberettigede", møteId, spesifikasjon);
        return this.ressurs["oppdaterStemmeberettigede"](
            _.defaults({id: møteId}, spesifikasjon),
            _.noop,
            this.håndterFeil(()=>this.gettextCatalog.getString("Kunne ikke oppdatere stemmeberettigede"))
        );
    }

    åpneForAvstemning(møteId: string, spesifikasjon: l.ÅpneStengeForAvstemningSpesifikasjon): l.AvstemningsstatusModell {
        debug("åpneForAvstemning", møteId, spesifikasjon)
        return this.ressurs["åpneForAvstemning"](
            _.defaults({id: møteId}, spesifikasjon),
            _.noop,
            this.håndterFeil(()=>this.gettextCatalog.getString("Kunne ikke åpne for avstemning"))
        );
    }

    stengForAvstemning(møteId: string, spesifikasjon: l.ÅpneStengeForAvstemningSpesifikasjon): l.AvstemningsstatusModell {
        debug("stengForAvstemning", møteId, spesifikasjon)
        return this.ressurs["stengForAvstemning"](
            _.defaults({id: møteId}, spesifikasjon),
            _.noop,
            this.håndterFeil(()=>this.gettextCatalog.getString("Kunne ikke stenge for avstemning"))
        );
    }

    nullstillAvgitteStemmer(møteId: string): l.AvstemningsstatusModell {
        debug("nullstillAvgitteStemmer", møteId)
        return this.ressurs["nullstillAvgitteStemmer"](
            {id: møteId},
            _.noop,
            this.håndterFeil(()=>this.gettextCatalog.getString("Kunne ikke nullstille avgitte stemmer"))
        );
    }

    nullstillAvgitteStemmerForDeltaker(møteId: string, deltakerId:string): l.AvstemningsstatusModell {
        debug("nullstillAvgitteStemmerForDeltaker", møteId)
        return this.ressurs["nullstillAvgitteStemmerForDeltaker"](
            {id: møteId, deltakerId:deltakerId},
            _.noop,
            this.håndterFeil(()=>this.gettextCatalog.getString("Kunne ikke nullstille avgitte stemmer"))
        );
    }

    hentSkjerming(møteId: string): l.SkjermingDetaljerModell {
        debug("hentSkjerming", møteId);
        return this.ressurs['hentSkjerming'](
            {id: møteId},
            _.noop,
            this.håndterFeil(() => this.gettextCatalog.getString('Kunne ikke hente møte'))
        );
    }

    oppdaterSkjerming(møteId: string, spesifikasjon:l.OppdaterSkjermingSpesifikasjon): l.SkjermingDetaljerMedValideringsresultatModell<l.SkjermingValideringsfeil> {
        debug("oppdaterSkjerming", møteId);
        return this.ressurs['oppdaterSkjerming'](
            _.defaults({id: møteId}, spesifikasjon),
            _.noop,
            this.håndterFeil(() => this.gettextCatalog.getString('Kunne ikke oppdatere tilgangsbegrensning'))
        );
    }

    publiserMøte(møteId: string, spesifikasjon: l.MøtepubliseringSpesifikasjon): l.ValideringsresultatModell<l.MøtePubliseringValideringsfeil> {
        debug("publiserMøte", møteId, spesifikasjon);
        return this.ressurs['publiserMoete'](
            _.defaults({id: møteId}, spesifikasjon),
            _.noop,
            this.håndterFeil(() => this.gettextCatalog.getString('Kunne ikke publisere møte'))
        );
    }

    sendEpost(møteId: string, spesifikasjon: l.GenerellEpostTilMedlemmerSpesifikasjon): l.SendEpostResultatModell {
        debug("sendEpost", møteId, spesifikasjon);
        return this.ressurs['sendEpost'](
          _.defaults({id: møteId}, spesifikasjon),
          _.noop,
          this.håndterFeil(() => this.gettextCatalog.getString('Kunne ikke sende epost om møte'))
        );
    }

    oppdaterMøtedokumentvalg(møteId: string, spesifikasjon: l.OppdaterMøtedokumentvalgSpesifikasjon): l.MøtedokumentvalgModell {
        debug("oppdaterMøtedokumentvalg", møteId, spesifikasjon);
        return this.ressurs['oppdaterMøtedokumentvalg'](
            _.defaults({id: møteId}, spesifikasjon),
            _.noop,
            this.håndterFeil(() => this.gettextCatalog.getString('Kunne ikke oppdatere møtedokumentvalg'))
        );
    }

    // hjelpemetoder

    /** Returnerer den deltakter blandt møtets deltakere som er innlogget (dvs kallende bruker) */
    finnInnloggetDeltaker(møte: l.MøteModell): l.MøtedeltakerModell {
        return _(møte.deltakere).find(
            deltaker => deltaker.medlem.brukerId == this.kontekst.autentisertBrukersId());
    }

    /** Innlogget brukers deltakerstatus, eller null dersom bruker ikke er deltaker i møtet */
    finnInnloggetBrukersMøtedeltakerstatus(møte: l.MøteModell): l.Deltakerstatus {
        var deltaker = this.finnInnloggetDeltaker(møte);
        return deltaker ? deltaker.status : null;
    }

    /** Returnerer sann dersom innlogget bruker
     * er deltaker på angitt møte
     * og innkallt
     * og vedkommende ikke har besvart innkalling */
    innloggetDeltakerHarIkkeBesvartInnkalling(møte: l.MøteModell): boolean {
        return this.finnInnloggetBrukersMøtedeltakerstatus(møte) == l.Deltakerstatus.innkalling_sendt;
    }

    møteevalueringsstatus(møte: l.MøteModell): MøteevalueringsStatus {
        let møtesluttPasert = moment(møte.dato.slutt).isBefore();
        let innloggetDeltaker = this.finnInnloggetDeltaker(møte);
        if (!møtesluttPasert) return MøteevalueringsStatus.kanIkkeVises;
        if (innloggetDeltaker && innloggetDeltaker.vurdering == null) return MøteevalueringsStatus.kanRegistreres;
        return MøteevalueringsStatus.kanVises;
    }

    public møtedokumentUrl(møte: {id:string, tittel: string, nummer: string}) {
        const filnavn = Filer.somSikkertFilnavn(`${møte.tittel}-${møte.nummer}`)
        return `${this.konfigurasjon.serviceRotUrl}/api/moete/${møte.id}/pdf/${uriEnkodet(filnavn)}.pdf`
    }

    public agendadokumentUrl(møte: {id:string, tittel: string, nummer: string}) {
        const prefiks = this.gettextCatalog.getString('agenda')
        const filnavn = Filer.somSikkertFilnavn(`${prefiks}-${møte.tittel}-${møte.nummer}`)
        return `${this.konfigurasjon.serviceRotUrl}/api/moete/${møte.id}/agenda/pdf/${uriEnkodet(filnavn)}.pdf`
    }

    public protokolldokumentUrl(møte: {id:string, tittel: string, nummer: string}, møtenavn = '') {
        const prefiks = this.gettextCatalog.getString('protokoll')
        const filnavn = Filer.somSikkertFilnavn(`${prefiks}-${møte.tittel}-${møte.nummer}`)
        return `${this.konfigurasjon.serviceRotUrl}/api/moete/${møte.id}/protokoll/pdf/${uriEnkodet(filnavn)}.pdf`
    }

    static finnMedlemmerSomIkkeDeltar(deltakere: l.MøtedeltakerModell[], gruppe: l.GruppeModell): l.GruppeMedlemListeModell[] {
        return _(gruppe.medlemmer)
            .reject(medlem => _(deltakere).some(deltaker => deltaker.medlem.id === medlem.id))
            .value();
    }

    static deltakerAvatarKlasse(deltaker: l.MøtedeltakerModell) {
        if (deltaker.status === l.Deltakerstatus.akseptert) return "groenn";
        if (deltaker.status === l.Deltakerstatus.avslaatt) return "roed";
        if (deltaker.status === l.Deltakerstatus.innkalling_sendt) return "gul";
        return "";
    }

    static deltakerSvarstatus(deltaker: l.MøtedeltakerModell, gettextCatalog: gettextCatalog) {
        ///deltakers deltakerstatus - innkalling akseptert
        if (deltaker.status === l.Deltakerstatus.akseptert) return gettextCatalog.getString("Godtatt");
        ///deltakers deltakerstatus - innkalling avslått
        if (deltaker.status === l.Deltakerstatus.avslaatt) return gettextCatalog.getString("Avslått");
        ///deltakers deltakerstatus - innkalling sendt men ikke svart
        if (deltaker.status === l.Deltakerstatus.innkalling_sendt) return gettextCatalog.getString("Sendt");
        ///deltakers deltakerstatus - innkalling ikke sendt
        if (deltaker.status === l.Deltakerstatus.innkalling_ikke_sendt) return gettextCatalog.getString("Ikke sendt");
        return "";
    }

    public deltakerinformasjon(møte: l.MøteModell): Deltakerinformasjon {
        let deltaker = this.finnInnloggetDeltaker(møte);
        let deltakereEtterStatus = _(møte.deltakere).groupBy("status").value();
        let godtatt = deltakereEtterStatus[l.Deltakerstatus.akseptert] || [];
        let avslått = deltakereEtterStatus[l.Deltakerstatus.avslaatt] || [];
        let ikkeSvart = deltakereEtterStatus[l.Deltakerstatus.innkalling_sendt] || [];
        let ikkeSendt = deltakereEtterStatus[l.Deltakerstatus.innkalling_ikke_sendt] || [];

        return {
            aktivBrukerInvitert: deltaker ? true : false,
            aktivBrukersStatus: deltaker ? deltaker.status : null,
            aktivBrukerKanBesvareInvitasjon: deltaker ? !_([l.Deltakerstatus.akseptert, l.Deltakerstatus.avslaatt, Deltakerstatus.innkalling_ikke_sendt]).includes(deltaker.status) : null,
            antallInvitert: møte.deltakere.length,
            godtatt: godtatt,
            avslaatt: avslått,
            ikkeSvart: ikkeSvart,
            ikkeSendt: ikkeSendt,
            eksterne: møte.eksterneDeltakere
        }
    }

    /** Møtets varighet i minutter */
    public static møtevarighet(møte: { dato: l.MøteDato }): number {
        return moment(møte.dato.start).twix(møte.dato.slutt).length("minutes");
    }

    /**
     * Møtets varighet i minutter, basert på sakenes beregnede varighet.
     * beregnetSlutt angir antall minutter mellom møtets angitte varighet og beregnet varighet, positivt dersom summen av sakene er større enn møtets angitte varighet
     */
    public static beregnetMøtevarighet(møte: { dato: l.MøteDato, saker: { id: string, varighet: number }[] }): BeregnetMøtevarighet {
        const sakstidspunkter = SakRessurs.sakstidspunkter(møte);
        const beregnetVarighet = _(sakstidspunkter).values().map("varighet").sum();
        const beregnetSlutt = moment(møte.dato.start).add(beregnetVarighet, "minutes");
        const beregnetErEtterSlutt = beregnetSlutt.isAfter(møte.dato.slutt);
        const angittVarighet = moment(møte.dato.start).twix(møte.dato.slutt).length("minutes");
        return {
            angittVarighet: angittVarighet,
            beregnetVarighet: beregnetVarighet,
            justertVarighet: beregnetErEtterSlutt ? beregnetVarighet : angittVarighet,
            justertSlutt: beregnetErEtterSlutt ? beregnetSlutt.toDate() : møte.dato.slutt,
            justertErEtterSlutt: beregnetErEtterSlutt,
            differanse: beregnetSlutt.twix(møte.dato.slutt).length("minutes") * -1
        }
    }
    /**
     * Møtets varighet i minutter, basert på sakenes beregnede varighet.
     * beregnetSlutt angir antall minutter mellom møtets angitte varighet og beregnet varighet, positivt dersom summen av sakene er større enn møtets angitte varighet
     */
    public static beregnetMøtevarighet2(møte: { dato: l.MøteDato}, sakstidspunkter:SakstidspunkterMap): BeregnetMøtevarighet {
        const beregnetVarighet = Array.from(sakstidspunkter.values()).map(v => v.varighet?.total('minutes') ?? 0).reduce(...reduserTilSum());
        const beregnetSlutt = moment(møte.dato.start).add(beregnetVarighet, "minutes");
        const beregnetErEtterSlutt = beregnetSlutt.isAfter(møte.dato.slutt);
        const angittVarighet = moment(møte.dato.start).twix(møte.dato.slutt).length("minutes");
        return {
            angittVarighet: angittVarighet,
            beregnetVarighet: beregnetVarighet,
            justertVarighet: beregnetErEtterSlutt ? beregnetVarighet : angittVarighet,
            justertSlutt: beregnetErEtterSlutt ? beregnetSlutt.toDate() : møte.dato.slutt,
            justertErEtterSlutt: beregnetErEtterSlutt,
            differanse: beregnetSlutt.twix(møte.dato.slutt).length("minutes") * -1
        }
    }
}

export interface BeregnetMøtevarighet {
    /** Møtets oppgitte varighet, som antall minutter mellom møte.start og møte.slutt */
    angittVarighet: number;
    /** Summen av varigheten til alle sakene i møtet, i minutter, kan være mindre eller større enn angittVarighet.
     * Merk at dersom minst en av sakene i møtet ikke har satt varighet vil beregnet varighet aldri være mindre enn angittVarighet */
    beregnetVarighet: number;
    /** Justert varighet i minutter, den største av angittVarighet og beregnetVarighet */
    justertVarighet: number;
    /** Justert møtesluttdato, den største av møte.slutt og møte.start + beregnetVarighet */
    justertSlutt: Date;
    /** Sann dersom justertSlutt er etter møte.slutt */
    justertErEtterSlutt: boolean;
    /** Antall minutter mellom angittVarighet og beregnetVarighet, negativ dersom beregnetVarighet er mindre enn angittVarighet */
    differanse: number
}

export interface Deltakerinformasjon {
    aktivBrukerInvitert: boolean;
    aktivBrukersStatus: l.Deltakerstatus;
    aktivBrukerKanBesvareInvitasjon: boolean;
    antallInvitert: number;
    godtatt: l.MøtedeltakerModell[];
    avslaatt: l.MøtedeltakerModell[];
    ikkeSvart: l.MøtedeltakerModell[];
    ikkeSendt: l.MøtedeltakerModell[];
    eksterne: l.EksternMøtedeltakerModell[];
}


export enum MøteevalueringsStatus {kanIkkeVises, kanVises, kanRegistreres}

